import React from "react";

const STATUS_LABELS = {
  pending: "Pending",
  approved: "Approved",
  rejected: "Rejected",
  cancelled: "Cancelled",
  attended: "Attended",
};

const InviteFlowStatusBadge = ({ status }) => {
  return (
    <span className={`inviteflow-badge inviteflow-badge--${status}`}>
      {STATUS_LABELS[status] || status}
    </span>
  );
};

export default InviteFlowStatusBadge;
